import React, { useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
  TableFooter,
  TablePagination,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../../common/actions/CommonActions";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../../vacancyApplication/VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";
import { Redirect } from "react-router-dom";
import { UsersRepository } from "../../administration/users/UsersRepository";
import { useEffect } from "react";

export default function VacancyAdditionalDataRequired() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [vacancyApps, setVacancyApps] = React.useState();
  const [allVacancyApps, setAllVacancyApps] = React.useState();
  const [totalAppsRemaining, setTotalAppsRemaining] = React.useState(0);
  const [redirect, setRedirect] = React.useState();
  const [vacancies, setVacancies] = useState();
  const [selectedVacancy, setSelectedVacancy] = useState("");
  const [commisions, setCommisions] = useState();

  const [loading, setLoading] = useState(false);
  const [firstNameSearch, setFirstNameSearch] = useState("");
  const [lastNameSearch, setLastNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [selectedVacancyApp, setSelectedVacancyApp] = useState();

  React.useEffect(() => {
    dispatch(changePageTitle(`${LOCALE.applications_to_be_finished}`));
  }, [dispatch]);

  React.useEffect(() => {
    setLoading(true);
    VacancyAppRepository.allAdditionalDataRequiredByVacancyId({
      vacancyId: selectedVacancy,
    }).then(
      (res) => {
        setTotalAppsRemaining(res.data.length);
        setVacancyApps(res.data);
        setAllVacancyApps(res.data);
        setLoading(false);
        console.log(res.data);
      },
      (err) => {
        setLoading(false);
      }
    );
  }, [selectedVacancy]);

  React.useEffect(() => {
    fetchAllCommisions();
    VacancyRepository.fetchAllVacancy({
      page: 0,
      size: 100,
      orderBy: "dateCreated",
      orderDirection: "DESC",
    }).then((res) => {
      setVacancies(res.data.content);
    });
  }, []);

  const fetchAllCommisions = () => {
    UsersRepository.allCommisionUsers().then((res) => {
      setCommisions(res.data);
    });
  };

  const transfer = (vacancyAppId, commisionId) => {
    console.log(vacancyAppId, commisionId);
    setLoading(true);
    VacancyAppRepository.transferVacancyApp(vacancyAppId, commisionId).then(
      (res) => {
        console.log(res.data);
        //update vacancyApps state, replace vacancyApp with new one
        let newVacancyApps = [...vacancyApps];

        newVacancyApps.forEach((element) => {
          if (element.id === vacancyAppId) {
            element.assignedTo = commisionId;
          }
        });
        setVacancyApps(newVacancyApps);
        setLoading(false);
        dispatch(notifyShowSuccessMessage("Успешно префрлена апликација"));
      },
      (err) => {
        setLoading(false);
        dispatch(notifyShowErrorMessage("Грешка при префрлање на апликација"));
      }
    );
  };

  useEffect(() => {
    if (firstNameSearch || lastNameSearch || emailSearch) {
      let filtered = allVacancyApps.filter((item) => {
        if (
          firstNameSearch &&
          !item.basicInfo.firstName.includes(firstNameSearch)
        )
          return false;
        if (lastNameSearch && !item.basicInfo.lastName.includes(lastNameSearch))
          return false;
        if (emailSearch && !item.basicInfo.email.includes(emailSearch))
          return false;
        return true;
      });
      setVacancyApps(filtered);
    } else {
      setVacancyApps(allVacancyApps);
    }
  }, [firstNameSearch, lastNameSearch, emailSearch]);

  const openVacancy = (vacId, appId) => {
    //open vacancy preview in new tab
    window.open("/app/vacancy-preview/" + vacId + "/" + appId, "_blank");
  };

  const handleChangeStatus = () => {
    VacancyAppRepository.updateStatus(selectedVacancyApp.id, "SUBMITTED").then(
      (res) => {
        dispatch(
          notifyShowSuccessMessage(LOCALE.application_submited_sucessfully)
        );
        setConfirmationDialogOpen(false);
        VacancyAppRepository.allAdditionalDataRequiredByVacancyId({
          vacancyId: selectedVacancy,
        }).then(
          (res) => {
            setTotalAppsRemaining(res.data.length);
            setVacancyApps(res.data);
            setAllVacancyApps(res.data);
            setLoading(false);
            console.log(res.data);
          },
          (err) => {
            setLoading(false);
          }
        );
      },
      (err) => {}
    );
  };
  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <FormControl
            className={classes.formControl}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel id="demo-simple-select-label1">
              {LOCALE.choose_vacancy}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label1"
              id="demo-simple-select1"
              label={LOCALE.choose_vacancy}
              value={selectedVacancy}
              onChange={(e) => setSelectedVacancy(e.target.value)}
            >
              <MenuItem key={221312} value={""}>
                {LOCALE.all}
              </MenuItem>
              {vacancies?.map((item, index) => (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={LOCALE.firstName}
            variant="outlined"
            size="small"
            fullWidth
            value={firstNameSearch}
            onChange={(e) => setFirstNameSearch(e.target.value)}
            disabled={allVacancyApps?.length === 0}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={LOCALE.lastName}
            variant="outlined"
            size="small"
            fullWidth
            value={lastNameSearch}
            onChange={(e) => setLastNameSearch(e.target.value)}
            disabled={allVacancyApps?.length === 0}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={LOCALE.email}
            variant="outlined"
            size="small"
            fullWidth
            value={emailSearch}
            onChange={(e) => setEmailSearch(e.target.value)}
            disabled={allVacancyApps?.length === 0}
          />
        </Grid>
      </Grid>
      <br></br> <br></br>
      <Card>
        <CardHeader color="theme">
          <Typography>
            {LOCALE.managing_applications_additional_info}
          </Typography>

          <Typography style={{ float: "right" }}>
            {LOCALE.total}: {totalAppsRemaining}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell></TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  {LOCALE.fullName}
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  {LOCALE.email}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.school}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.teaching_languages}
                </TableCell>

                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {"Рок за доработка"}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.status}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "50px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vacancyApps &&
                vacancyApps.length === 0 &&
                (loading ? (
                  <>
                    <TableRow>
                      <TableCell colSpan={10} style={{ textAlign: "center" }}>
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={10}>
                      <Icon
                        style={{ verticalAlign: "bottom", color: "orange" }}
                      >
                        warning
                      </Icon>
                      {LOCALE.no_apps_for_evaluating}
                    </TableCell>
                  </TableRow>
                ))}
              {vacancyApps &&
                vacancyApps?.map((vacancyApp, index) => (
                  <TableRow
                    key={index}
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{`${vacancyApp?.basicInfo?.firstName} ${vacancyApp?.basicInfo?.lastName}`}</TableCell>
                    <TableCell>{vacancyApp?.basicInfo?.email}</TableCell>

                    <TableCell>{vacancyApp.basicInfo.school.name}</TableCell>
                    <TableCell>
                      {LOCALE.getString(vacancyApp.basicInfo.teachingLanguage)}
                    </TableCell>

                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.submissionDate &&
                        moment(vacancyApp.submissionDate).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.additionalDataRequiredDueDate &&
                        moment(vacancyApp.additionalDataRequiredDueDate).format(
                          "YYYY-MM-DD "
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.status && (
                        <Chip
                          label={LOCALE.getString(vacancyApp.status)}
                          style={{
                            color: "white",
                            backgroundColor: "orange",
                          }}
                        />
                      )}
                      {vacancyApp?.additionalDataRequiredComment && (
                        <Tooltip
                          title={`Причина: ${vacancyApp?.additionalDataRequiredComment}`}
                          arrow
                          placement="top"
                        >
                          <IconButton size="small">
                            <Icon>question_mark</Icon>
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>

                    <TableCell style={{ width: "80px" }}>
                      <Tooltip
                        title={"Преглед на апликација"}
                        arrow
                        placement="top"
                      >
                        <IconButton
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={() =>
                            openVacancy(vacancyApp.vacancy.id, vacancyApp.id)
                          }
                        >
                          <Icon size={10}>preview</Icon> &nbsp;
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={"Врати кај комисија"}
                        arrow
                        placement="top"
                      >
                        <IconButton
                          color="secondary"
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setConfirmationDialogOpen(true);
                            setSelectedVacancyApp(vacancyApp);
                          }}
                        >
                          <Icon size={10}>restore</Icon> &nbsp;
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      <Dialog
        open={confirmationDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Потврда"}</DialogTitle>
        <DialogContent>
          {selectedVacancyApp && (
            <DialogContentText id="alert-dialog-description">
              Апликација на: {selectedVacancyApp.basicInfo.firstName}{" "}
              {selectedVacancyApp.basicInfo.lastName}
            </DialogContentText>
          )}

          {selectedVacancyApp &&
            selectedVacancyApp.additionalDataRequiredComment && (
              <DialogContentText id="alert-dialog-description">
                Причина за доработка:{" "}
                {selectedVacancyApp.additionalDataRequiredComment}
              </DialogContentText>
            )}
          {selectedVacancyApp &&
            selectedVacancyApp.additionalDataRequiredDueDate && (
              <DialogContentText id="alert-dialog-description">
                Рок за доработка:{" "}
                {moment(
                  selectedVacancyApp.additionalDataRequiredDueDate
                ).format("YYYY-MM-DD ")}
              </DialogContentText>
            )}

          <DialogContentText id="alert-dialog-description">
            Дали сте сигурни дека сакате да ја вратите апликацијата кај комисија
            пред предвидениот рок за доработка?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmationDialogOpen(false);
              setSelectedVacancyApp(null);
            }}
            color="primary"
          >
            Назад
          </Button>
          <Button
            onClick={() => handleChangeStatus()}
            color="secondary"
            autoFocus
          >
            Да
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
